
import downloadFile from '@/utils/downloadFile'

import Transformer from '@/transformers/transformer'

const SINISTERS_PER_PROCESS = 45
const SinisterTransformer = ({
  sinister_id: id, sinister_number: sinisterNumber,
  assignment_date: assignmentDate, slug, affected_count: affectedCount,
  affectedsalternateprocesses: affectedAlternateProcesses, supervisor
}) => ({
  id, sinisterNumber, assignmentDate, slug, affectedCount, supervisor,
  affectedAlternateProcesses: affectedAlternateProcesses ? affectedAlternateProcesses.split(",") : null
})

class SinistersTransformer extends Transformer {
  static fetch({ avg, count, data }) {
    return {
      avg, count, data: data ? data.map(SinisterTransformer) : []
    }
  }
}

const paramsTransformer = ({
  fromDate, toDate, supervisors, acos, customers, zones, jobTypes, processes
}) => (
  {
    toDate: toDate || undefined,
    fromDate: fromDate || undefined,
    supervisor: (supervisors && supervisors.length) ? supervisors.join(',') : undefined,
    aco_username: (acos && acos.length) ? acos.join(',') : undefined,
    zone: (zones && zones.length) ? zones.join(',') : undefined,
    customer: (customers && customers.length)  ? customers.join(',') : undefined,
    typeSinister: (jobTypes && jobTypes.length) ? jobTypes.join(',') : undefined,
    processes: (processes && processes.length) ? processes.join(',') : undefined,
  }
)

/**
 * Get CSV Macro report
 * @return {Promise} An http GET request
 */
const fetchSinisters = (filters = {}) => {
  const transformedParams = paramsTransformer(filters)

  const config = {
    params: {
      ...transformedParams,
    }
  }
    const filename = `Macro.csv`
    return downloadFile(`sinister/csv/macro_process/`, filename, { config })
}

export default fetchSinisters